export const getPaidSeats = ({
  seatsInventory
}) => {
  const paidSeats = seatsInventory.paidSeats;
  return paidSeats || [];
};
export const getTotalNumberOfAccountUsers = ({
  seatsInventory
}) => {
  const paidSeats = getPaidSeats({
    seatsInventory
  });

  if (!paidSeats.length) {
    return 0;
  }

  const total = paidSeats.reduce((acc, paidSeat) => acc + paidSeat.currentAssignedSeats, 0);
  return total;
};